export default "__VITE_ASSET__n$3nXY36__"